import { createTypes } from 'redux-recompose';

export const actionsSelect = createTypes(['APPLY_SELECT_SEARCHBOX', 'APPLY_SELECT_MODALE', 'APPLY_SELECT_INITIAL_MODALE'], '@@PML');

const actionCreators = {
    APPLY_SELECT_SEARCHBOX: (response) => ({ type: actionsSelect.APPLY_SELECT_SEARCHBOX, notification: response }),
    APPLY_SELECT_MODALE: (response) => ({ type: actionsSelect.APPLY_SELECT_MODALE, notification: response }),
};

export default actionCreators;